import { CmsIcons } from '@redteclab/api/clients/content-management-system'
import classNames from 'clsx'
import { Fragment, type ReactNode, Suspense, type VFC } from 'react'

import { IS_NODE } from 'shared/consts'
import ButtonBlockMenu from 'views/components/molecules/ButtonBlockMenu'
import ErxDecorator from 'views/components/organisms/CmsMobileMenu/ErxDecorator'
import { getTagsFromString } from 'views/components/organisms/CmsMobileMenu/helpers'
import type { ItemProps } from 'views/components/organisms/CmsMobileMenu/types'
import { getRebrandingMenubarIcons } from 'views/components/organisms/MenubarCms/helper'

import './Item.scss'

const SuspenseWrapper = IS_NODE
  ? Fragment
  : ({ children }: { children?: ReactNode }) => (
      <Suspense fallback={null}>{children}</Suspense>
    )

const Item: VFC<ItemProps> = props => {
  const {
    children,
    goNextHandler,
    hasErxAnnouncement,
    href,
    icon,
    name,
    tags,
    type,
    className,
  } = props
  const availableTags = getTagsFromString(tags || [])

  const hasChildren = availableTags?.expandable

  const onClickHandler =
    goNextHandler && hasChildren
      ? goNextHandler('', href, { fetchByPath: true })
      : null

  const itemProps = {
    ghost: availableTags?.ghost || false,
    hasChildren,
    href,
    isReactControlled: true,
    light: true,
    name,
    onClick: onClickHandler,
    type: type || 'button',
  }

  const Icon = icon ? getRebrandingMenubarIcons(icon) : null

  return (
    <ButtonBlockMenu {...itemProps}>
      {Icon && (
        <SuspenseWrapper>
          <Icon
            className={classNames('u-margin-xx-small--right', {
              'u-color--red m-ItemList__Item__red-points-icon':
                icon === CmsIcons.Redpoints,
              'm-Item__doctor-icon': icon === CmsIcons.Ods,
            })}
          />
        </SuspenseWrapper>
      )}
      <span className={classNames('l-flex__grow-one', className)}>
        {children}
      </span>
      {hasErxAnnouncement && <ErxDecorator />}
    </ButtonBlockMenu>
  )
}

Item.defaultProps = {
  hasErxAnnouncement: false,
  href: null,
  name: '',
  type: null,
}

export default Item
